// The session cache (ruled: cache-with-revalidate). The hydrated user is
// stored next to the token through the same storage seam so boot can PAINT
// immediately from the cached copy while get-me revalidates in the
// background. The cached copy is DISPLAY ONLY — no client decision trusts
// it, and every real decision stays server-side behind Cedar. A malformed or
// missing cache is simply "nothing to paint".

import { useIdentityStorage } from '../adapters/ports.js';

const CACHED_USER_KEY = 'aac.user.v1';

export async function getCachedUser() {
  try {
    const raw = await useIdentityStorage().get(CACHED_USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export async function setCachedUser(user) {
  try {
    if (user) {
      await useIdentityStorage().set(CACHED_USER_KEY, JSON.stringify(user));
    } else {
      await useIdentityStorage().remove(CACHED_USER_KEY);
    }
  } catch {
    // The cache is a convenience; losing a write costs one boot's paint.
  }
}

export const cachedUserStorage = { getCachedUser, setCachedUser };
export default cachedUserStorage;
